<template lang="html">
  <div class="container" v-if="wrapClasses">
    <div class="columns is-multiline">
      <div :class="wrapClasses">
        <div class="content" v-html="rawhtml">
        </div>
      </div>
    </div>
  </div>
  <div class="" v-else="">
    <div class="content" v-html="rawhtml">
    </div>
  </div>
</template>

<script>
  import renderBlocks from '@/renderBlocks'
  export default {
    data () {
      return {
        rawhtml: renderBlocks(this.blocks)
      }
    },
    props: ['blocks', 'wrapClasses']
  }
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/TextBlock.vue